"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendFeesToTurret = exports.GetTurretFeeBalances = exports.RunContract = void 0;
var tslib_1 = require("tslib");
var stellar_sdk_1 = require("stellar-sdk");
var yieldblox_base_1 = require("yieldblox-base");
var TurretOrchestrator_1 = require("./TurretOrchestrator");
var YbxError_1 = require("../YbxError");
function RunContract(token, request, turrets, contractHash) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, _runContract(token, request, turrets, contractHash)];
                case 1: return [2, _a.sent()];
            }
        });
    });
}
exports.RunContract = RunContract;
function GetTurretFeeBalances(turret, authToken) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var turretOrchestrator, response;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    turretOrchestrator = new TurretOrchestrator_1.TurretOrchestrator();
                    return [4, turretOrchestrator.ExecuteGetFeeBalanceAsync(turret, authToken)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.response) !== undefined) {
                        return [2, response.response];
                    }
                    throw new YbxError_1.YbxError("GetTurretFeeBalances: ".concat(response === null || response === void 0 ? void 0 : response.statusCode, ": ").concat(response === null || response === void 0 ? void 0 : response.error));
            }
        });
    });
}
exports.GetTurretFeeBalances = GetTurretFeeBalances;
function SendFeesToTurret(turret, publicKey, paymentXdr) {
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var turretOrchestrator, response;
        return (0, tslib_1.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    turretOrchestrator = new TurretOrchestrator_1.TurretOrchestrator();
                    return [4, turretOrchestrator.ExecutePayFeeBalanceAsync(turret, publicKey, paymentXdr)];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.response) !== undefined) {
                        return [2, response.response];
                    }
                    throw new YbxError_1.YbxError("SendFeesToTurret: ".concat(response === null || response === void 0 ? void 0 : response.statusCode, ": ").concat(response === null || response === void 0 ? void 0 : response.error));
            }
        });
    });
}
exports.SendFeesToTurret = SendFeesToTurret;
function _runContract(token, request, turrets, contractHash) {
    var _a, _b, _c;
    return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
        var turretOrchestrator, contractExecutionResults, contractExecutionAwaiters, totalCost, xdrGroups, firstResult, largestGroup, largestGroupCount, errCount, errStr, error, error, error, horizon, tx, signers;
        return (0, tslib_1.__generator)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    request.timestamp = Date.now();
                    turretOrchestrator = new TurretOrchestrator_1.TurretOrchestrator();
                    contractExecutionResults = [];
                    contractExecutionAwaiters = [];
                    turrets.forEach(function (x) {
                        contractExecutionAwaiters.push(turretOrchestrator.ExecuteContractAsync(x, request, token, contractHash));
                    });
                    return [4, Promise.all(contractExecutionAwaiters)];
                case 1:
                    contractExecutionResults = _d.sent();
                    totalCost = 0.0;
                    xdrGroups = new Map();
                    largestGroup = [];
                    largestGroupCount = -1;
                    contractExecutionResults.forEach(function (x) {
                        var _a;
                        var code = ((_a = x.response) === null || _a === void 0 ? void 0 : _a.xdr) || "";
                        xdrGroups.set(code, (xdrGroups.get(code) || 0) + 1);
                        var newMax = xdrGroups.get(code) || 0;
                        if (newMax > largestGroupCount) {
                            largestGroupCount = newMax;
                            largestGroup.push(x);
                            firstResult = x;
                        }
                    });
                    if (largestGroupCount < turrets.length * 0.6) {
                        errCount = turrets.length - largestGroupCount;
                        errStr = "".concat(errCount, " Turrets returned different XDRs. Please try again.");
                        error = new YbxError_1.YbxError(errStr);
                        error.responseError = errStr;
                        throw error;
                    }
                    if ((firstResult === null || firstResult === void 0 ? void 0 : firstResult.response) == null) {
                        error = new YbxError_1.YbxError("No response from turret: ".concat(firstResult === null || firstResult === void 0 ? void 0 : firstResult.error));
                        error.responseError = firstResult === null || firstResult === void 0 ? void 0 : firstResult.error;
                        error.turretRunResponse = firstResult === null || firstResult === void 0 ? void 0 : firstResult.response;
                        throw error;
                    }
                    if (((_a = firstResult === null || firstResult === void 0 ? void 0 : firstResult.response) === null || _a === void 0 ? void 0 : _a.xdr) == null) {
                        error = new YbxError_1.YbxError("Majority of turrets failed to execute contract. ".concat((_c = (_b = firstResult === null || firstResult === void 0 ? void 0 : firstResult.response) === null || _b === void 0 ? void 0 : _b.error) !== null && _c !== void 0 ? _c : firstResult === null || firstResult === void 0 ? void 0 : firstResult.error));
                        error.responseError = firstResult === null || firstResult === void 0 ? void 0 : firstResult.error;
                        error.turretRunResponse = firstResult === null || firstResult === void 0 ? void 0 : firstResult.response;
                        throw error;
                    }
                    horizon = yieldblox_base_1.HorizonServer.getInstance();
                    tx = stellar_sdk_1.TransactionBuilder.fromXDR(firstResult.response.xdr, horizon.network);
                    signers = 0;
                    largestGroup.forEach(function (result) {
                        var _a, _b;
                        if (signers < turrets.length * 0.6) {
                            turretOrchestrator.ApplySignature((_a = result.response) === null || _a === void 0 ? void 0 : _a.signer, (_b = result.response) === null || _b === void 0 ? void 0 : _b.signature, tx);
                            signers += 1;
                        }
                    });
                    contractExecutionResults.forEach(function (x) {
                        var _a, _b;
                        var cost = parseFloat((_b = (_a = x.response) === null || _a === void 0 ? void 0 : _a.cost) !== null && _b !== void 0 ? _b : "0");
                        if (!isNaN(cost)) {
                            totalCost += cost;
                        }
                    });
                    return [2, {
                            signedXdr: tx.toXDR(),
                            cost: totalCost.toString(),
                            errorMessage: undefined,
                        }];
            }
        });
    });
}
//# sourceMappingURL=ybxApi.js.map